angular
  .module 'filters'
  .filter 'escape', () ->
    (string) ->
      _.escape string
